import LinkCustomerToQuickBooks from '../quickbooks/LinkCustomerToQuickBooks'
import { TimesheetRow } from './timesheetsApi'
import { useTimesheetsInvalidator } from './timesheetsQueries'

type Props = {
  row: TimesheetRow | null
  onClose: () => void
}

const TimesheetCustomerLink = ({ row, onClose }: Props) => {
  const invalidateTimesheets = useTimesheetsInvalidator()

  return <LinkCustomerToQuickBooks
    customerId={row?.customerId ?? undefined}
    customerDisplayName={row?.customer ?? ''}
    currentQboId={row?.customerQboId ?? undefined}
    currentQboDisplayName={row?.customerQboDisplayName ?? undefined}
    onSuccess={() => invalidateTimesheets()}
    onClose={onClose}
  />
}

export default TimesheetCustomerLink
